import { call, put, takeLatest } from 'redux-saga/effects';
import { getAvatar } from '../../services/API';

import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getInfo() {
  const response = yield call(getAvatar);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* avatarSaga() {
  yield takeLatest(actionTypes.GET_INFO, getInfo);
}
